export type LazyValue<T> = {
  readonly value: T;
  readonly hasValue: boolean;
  clear(): void;
};

export const lazy = <T>(fn: () => T): LazyValue<T> => {
  let data: { value: T } | undefined;
  return {
    get value() {
      if (!data) {
        data = { value: fn() };
      }
      return data.value;
    },
    get hasValue() {
      return !!data;
    },
    clear() {
      data = undefined;
    },
  };
};
